import React from 'react';

// By importing the image, we let the build tool (like Vite or Webpack) handle it.
// This ensures the image is copied to the build output and the path is correct.
// Assuming the assets folder is at `frontend2/assets`.
import logoImage from '../images/logos/matatai-logo-solve.png';

interface LogoProps {
  onClick?: () => void;
  showText?: boolean;
  textClassName?: string;
  containerClassName?: string;
  as?: 'h1' | 'h3'; // To handle h1 vs h3
  textSize?: 'text-xl' | 'text-2xl';
}

const Logo: React.FC<LogoProps> = ({
  onClick,
  showText = true,
  textClassName = 'text-sky-700',
  containerClassName = '',
  as: Component = 'h1',
  textSize = 'text-2xl',
}) => {
  const content = (
    <>
      <img src={logoImage} alt="AI Klikero Logo" className="h-8 w-8" />
      {showText && <Component className={`${textSize} font-bold hidden sm:inline ${textClassName}`}>
        <span className="inline-block bg-gradient-to-r from-sky-100 via-indigo-200 to-sky-200 bg-clip-text [text-shadow:0_2px_4px_rgba(0,0,0,0.1)]">klikero</span>
      </Component>}
    </>
  );

  const commonProps = {
    className: `flex items-center space-x-2 ${containerClassName}`,
  };

  if (onClick) {
    return (
      <div
        {...commonProps}
        onClick={onClick}
        className={`${commonProps.className} cursor-pointer`}
        title="Početna strana"
        role="button"
        tabIndex={0}
        onKeyPress={(e) => e.key === 'Enter' && onClick && onClick()}
      >
        {content}
      </div>
    );
  }

  return <div {...commonProps}>{content}</div>;
};

export default Logo;